import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users as UsersIcon, BarChart3, Eye } from 'lucide-react';
import OverviewWidgets from '../components/OverviewWidgets';
import Modal from '../components/Modal';
import UserAnalytics from '../components/analytics/UserAnalytics';
import DeviceAnalytics from '../components/analytics/DeviceAnalytics';
import AdherenceAnalytics from '../components/analytics/AdherenceAnalytics';
import AlertsAnalytics from '../components/analytics/AlertsAnalytics';
import DosesAnalytics from '../components/analytics/DosesAnalytics';
import ActivityAnalytics from '../components/analytics/ActivityAnalytics';
import TreatmentAnalytics from '../components/analytics/TreatmentAnalytics';
import ComplianceAnalytics from '../components/analytics/ComplianceAnalytics';
import CriticalAnalytics from '../components/analytics/CriticalAnalytics';
import './Users.css';

const Users = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWidget, setSelectedWidget] = useState(null);

  // Mock user data for widgets
  const users = [
    {
      id: 42,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '10.3%',
      scheduleAdherence: '15.9%',
      image: '15.9%',
      overallAdherence: '15.9%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 43,
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '10.3%',
      scheduleAdherence: '20.7%',
      image: '20.7%',
      overallAdherence: '20.7%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 44,
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '10.3%',
      scheduleAdherence: '10.3%',
      image: '10.3%',
      overallAdherence: '10.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 45,
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '10.3%',
      scheduleAdherence: '100%',
      image: '100%',
      overallAdherence: '100%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 46,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '10.3%',
      scheduleAdherence: '15.3%',
      image: '15.3%',
      overallAdherence: '15.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Not Assigned',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 47,
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '10.3%',
      scheduleAdherence: '35.8%',
      image: '35.8%',
      overallAdherence: '35.8%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 48,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '10.3%',
      scheduleAdherence: '1.3%',
      image: '1.3%',
      overallAdherence: '1.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    }
  ];

  const handleWidgetClick = (widgetType, data) => {
    setSelectedWidget({ type: widgetType, data });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedWidget(null);
  };

  const renderModalContent = () => {
    if (!selectedWidget) return null;

    const { type, data } = selectedWidget;

    switch (type) {
      case 'total-users':
        return <UserAnalytics />;
      case 'online-status':
        return <DeviceAnalytics />;
      case 'adherence-overview':
        return <AdherenceAnalytics />;
      case 'alerts':
        return <AlertsAnalytics />;
      case 'doses-today':
        return <DosesAnalytics />;
      case 'recent-activity':
        return <ActivityAnalytics />;
      case 'avg-treatment':
        return <TreatmentAnalytics />;
      case 'compliance-rate':
        return <ComplianceAnalytics />;
      case 'critical-patients':
        return <CriticalAnalytics />;
      default:
        return <div>Analytics data for {data.title}</div>;
    }
  };

  const getModalTitle = () => {
    if (!selectedWidget) return '';
    return selectedWidget.data.title;
  };

  return (
    <div className="overview-page">


      <OverviewWidgets users={users} onWidgetClick={handleWidgetClick} />

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="action-cards">
          <Link to="/users" className="action-card">
            <div className="action-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
              <UsersIcon size={24} />
            </div>
            <div className="action-content">
              <h3>Manage Patients</h3>
              <p>View, edit, and manage all patients in the study</p>
            </div>
            <Eye size={16} className="action-arrow" />
          </Link>

          <Link to="/analytics/adherence" className="action-card">
            <div className="action-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
              <BarChart3 size={24} />
            </div>
            <div className="action-content">
              <h3>View Analytics</h3>
              <p>Detailed adherence and performance analytics</p>
            </div>
            <Eye size={16} className="action-arrow" />
          </Link>
        </div>
      </div>

      <div className="recent-activity">
        <h2>Recent Activity</h2>
        <div className="activity-list">
          <div className="activity-item">
            <div className="activity-dot"></div>
            <div className="activity-content">
              <p><strong>Patient 47</strong> completed evening medication dose</p>
              <span className="activity-time">2 minutes ago</span>
            </div>
          </div>
          
          <div className="activity-item">
            <div className="activity-dot warning"></div>
            <div className="activity-content">
              <p><strong>Patient 44</strong> missed morning medication dose</p>
              <span className="activity-time">1 hour ago</span>
            </div>
          </div>

          <div className="activity-item">
            <div className="activity-dot"></div>
            <div className="activity-content">
              <p><strong>Patient 42</strong> device came back online</p>
              <span className="activity-time">3 hours ago</span>
            </div>
          </div>

          <div className="activity-item">
            <div className="activity-dot success"></div>
            <div className="activity-content">
              <p><strong>Patient 45</strong> achieved 7-day medication streak</p>
              <span className="activity-time">6 hours ago</span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        title={getModalTitle()}
        size="large"
      >
        {renderModalContent()}
      </Modal>
    </div>
  );
};

export default Users;
